import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IMealtime } from '../../types/mealtimes.types';

export const getMealtimes = async (menuId: string): Promise<IMealtime[]> => {
  const res = await fetch(`${API_URL}/menus/${menuId}/mealtimes`);
  if (res.status !== Status.SUCCESS) {
    throw new Error('Unable to fetch mealtimes');
  }
  const json = await res.json();

  return json.data;
};
